import React from 'react';
import styled from 'styled-components';
import DotIcon from '@material-ui/icons/FiberManualRecord';
//
import colors from 'theme/colors';

const DotIconContainer = styled.span`
  position: relative;
  top: 8px;
  margin-left: 4px;

  svg {
    width: 0.6em;
    color: ${colors.yellow};
  }
`;

const DotIconStyled = () => (
  <DotIconContainer>
    <DotIcon />
  </DotIconContainer>
);

export default DotIconStyled;
